const BoolType = (value: boolean): string => {
  return value ? "tak" : "nie";
};

const ValueOrNone = (value: any): string => {
  return value ? "" + value : "brak";
};

const BoolClass = (value: boolean): string => {
  return value ? "table__td-yes" : "table__td-no";
};

export { BoolType, ValueOrNone, BoolClass };
